import { action } from 'satcheljs';
import { ProofingViewState } from '../store/schema/ProofingViewState';
import { PremiumPreviewType } from '../store/schema/PremiumPreviewData';

export const updatePremiumPreviewData = action(
    'premiumPreviewActions',
    (
        viewState: ProofingViewState,
        premiumPreviewType: PremiumPreviewType,
        numerOfDaysLeft: number,
        shouldUpdateOptionSettings: boolean,
        premiumSuggestionsCount: number
    ) => ({
        viewState: viewState,
        premiumPreviewType: premiumPreviewType,
        numerOfDaysLeft: numerOfDaysLeft,
        shouldUpdateOptionSettings: shouldUpdateOptionSettings,
        premiumSuggestionsCount: premiumSuggestionsCount,
    })
);
